import { Controller } from "@hotwired/stimulus";

// Highlights server-rendered Action Text code blocks. Lexxy renders them as
// <pre data-language="...">, and Prism turns them into highlighted <code>.
//
// Prism and its grammars are pulled in on demand so pages without code blocks
// (including the lean public bundle) never download them.
export default class extends Controller {
  connect() {
    if (this.element.querySelector("pre[data-language]")) {
      this.highlight();
    }
  }

  async highlight() {
    // Prism is already global (lib/prism_global, loaded before Lexxy), which its
    // component files need to attach their grammars.

    // Grammars are side-effect imports that register themselves on Prism.
    // Order matters: later grammars extend earlier ones.
    await import("prismjs/components/prism-markup");
    await import("prismjs/components/prism-clike");
    await import("prismjs/components/prism-markup-templating");
    await import("prismjs/components/prism-bash");
    await import("prismjs/components/prism-diff");
    await import("prismjs/components/prism-go");
    await import("prismjs/components/prism-json");
    await import("prismjs/components/prism-php");
    await import("prismjs/components/prism-ruby");

    const { highlightCode } = await import("@37signals/lexxy/helpers");
    highlightCode();
  }
}
